import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import useProductContent from '@/composables/useProductContent/useProductContent';
import RichText from '~/components/ui/RichText.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'ItemPreparationStep',
  components: {
    RichText: RichText,
    AzImg: AzImg,
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    title: String,
    description: Object,
    number: Number,
    image: {
      type: Object,
      default: function _default() {}
    },
    phases: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    informations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    classes: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(_ref) {
    var informations = _ref.informations;
    var options = {
      renderNode: {
        paragraph: function paragraph(node, next) {
          return "<p class=\"preparation-step__text preparation-step__text--description\">".concat(next(node.content), "</p>");
        }
      }
    };
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var components = computed(function () {
      return mapComponentName(informations, {
        isPhased: true
      });
    });
    return {
      options: options,
      components: components
    };
  }
});